<script>
	import { Router, Route, navigate } from 'svelte-routing';
	
	import { authServer, token, isAuthenticated } from './stores.js';

	import Login from './Login.svelte';
	import Dashboard from './dashboard/Dashboard.svelte';
    import Inmate from './inmate/Inmate.svelte';

	// url variable required for routing.
	export let url = "";

	setInterval(function() {
		if ($isAuthenticated && localStorage.getItem("refresh") != null) {
			refreshAuthenticationToken();
		}
	}, 55 * 60 * 1000);  // 55 minute refresh interval

	const refreshAuthenticationToken = async () => {
		await fetch(`${$authServer}/auth/upp/token/refresh`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			body: JSON.stringify ({
				accessToken: $token,
				refreshToken: localStorage.getItem("refresh")
			})
		})
		.then(r => {
			if (!r.ok) {
				throw Error(r.status);
			}
			return r;
		})
		.then(r => r.json())
		.then(parsed => {
			if (parsed.accessToken) {
				token.set(parsed.accessToken);
				localStorage.setItem("refresh", parsed.refreshToken);
			} else {
				isAuthenticated.set(false);
				console.error("Access token expired");
				throw Error("INVALID_TOKEN");	
      		}
		})
		.catch(error => {
			isAuthenticated.set(false);
			console.error(error);
			navigate("/");
			return;
		});
	};
</script>

<Router url="{url}">
	<Route path="/" component={Login} />
	<Route path="/dashboard" component={Dashboard} />
	<Route path="/history/:id" component={Inmate} />
</Router>